import {Request} from '@group-devs/yfp7-global-modules'
import {NavDropdown, Image, Row, Col} from 'react-bootstrap'
import {FaChevronDown, FaLongArrowAltLeft} from "react-icons/fa"
import Link from 'next/link'
import { useState } from 'react'
const request = new Request(process.env.apiDomain)

function WSectionsNav(props) {
    
    const {data: wellness} = request.website.swrSite(props.site.accountId, "WC")

    return (
        <div className="sectiondropdown">
            <NavDropdown id="nav-dropdown" title={<div>
                <div className="d-lg-inline-block d-none">Sections <FaChevronDown className="h8 ml-1"/></div>
                <div className="d-lg-none d-inline-block">
                    <svg width="46" height="46">
                        <path d="M19.42,11.62H14.18a2.07,2.07,0,0,0-2.07,2.07v5.23A2.07,2.07,0,0,0,14.18,21h5.24a2.08,2.08,0,0,0,2.08-2.07V13.69A2.08,2.08,0,0,0,19.42,11.62Zm.56,7.3a.56.56,0,0,1-.56.55H14.18a.55.55,0,0,1-.55-.55V13.69a.55.55,0,0,1,.55-.55h5.24a.56.56,0,0,1,.56.55Zm-.56,5.3H14.18a2.08,2.08,0,0,0-2.07,2.08v5.22a2.07,2.07,0,0,0,2.07,2.07h5.24a2.08,2.08,0,0,0,2.08-2.07V26.3A2.08,2.08,0,0,0,19.42,24.22Zm.56,7.3a.56.56,0,0,1-.56.56H14.18a.56.56,0,0,1-.55-.56V26.3a.56.56,0,0,1,.55-.56h5.24a.56.56,0,0,1,.56.56Zm12-7.3H26.76a2.08,2.08,0,0,0-2.08,2.08v5.22a2.08,2.08,0,0,0,2.08,2.07H32a2.08,2.08,0,0,0,2.08-2.07V26.3A2.08,2.08,0,0,0,32,24.22Zm.55,7.3a.56.56,0,0,1-.55.56H26.76a.56.56,0,0,1-.56-.56V26.3a.56.56,0,0,1,.56-.56H32a.56.56,0,0,1,.55.56ZM29.38,21a4.69,4.69,0,1,0-4.7-4.69A4.7,4.7,0,0,0,29.38,21Zm0-7.85A3.17,3.17,0,1,1,26.2,16.3,3.17,3.17,0,0,1,29.38,13.14Z"/>
                    </svg>
                    <span className="footer-link">Sections</span>
                </div>
            </div>}>
                <div className="px-lg-4 px-0">
                    <Row>
                        {wellness ?
                        <>
                            <Col lg={6} className="py-3 border-right">
                                <div className="px-lg-0 px-3">
                                    <Row className="justify-content-end">
                                        <Col xl={8} lg={10}>
                                            <p><Link href="#"><a className="d-lg-none d-inline-block"><FaLongArrowAltLeft size="25" className="mr-3"/></a></Link><strong>Browse Wellness Sections</strong></p>
                                        </Col>
                                    </Row>
                                    <Row className="justify-content-end">
                                        <Col xl={4} lg={5}>
                                            <Link href={`/articles`} passHref><a className="d-block py-2">
                                                <Image width={35} src="/images/sections/img-articles-01.svg" alt="Articles" className="mr-2"/>Articles
                                            </a></Link>
                                            <Link href={`/replays`} passHref><a className="d-block py-2">
                                                <Image width={35} src="/images/sections/img-live-event-replays-01.svg" alt="Replays" className="mr-2"/>Replays
                                            </a></Link>
                                            <Link href={`/file-cabinet`} passHref><a className="d-block py-2">
                                                <Image width={35} src="/images/sections/img-wellness-files-01.svg" alt="Wellness Files" className="mr-2"/>Wellness Files
                                            </a></Link>
                                        </Col>
                                        <Col xl={4} lg={5}>
                                            <Link href={`/videos`} passHref><a className="d-block py-2">
                                                <Image width={35} src="/images/sections/img-video-library-01.svg" alt="Video Library" className="mr-2"/>Video Library
                                            </a></Link>
                                            <Link href={`/recipes`} passHref><a className="d-block py-2">
                                                <Image width={35} src="/images/sections/img-recipes-01.svg" alt="Recipes" className="mr-2"/>Recipes
                                            </a></Link>
                                            <Link href={`/explore/newsletter`} passHref><a className="d-block py-2">
                                                <Image width={35} src="/images/sections/img-archived-newsletters-01.svg" alt="Newsletters" className="mr-2"/>Newsletters
                                            </a></Link>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <hr className="m-0 d-lg-none d-block"/>
                            <Col lg={6} className="py-3">
                                <div className="pl-3">
                                    <p><strong>Explore Wellness</strong></p>
                                    <Link href={`/explore`}><a className="d-block py-2">
                                        <Image width={35} src="/images/sections/img-intro-01.svg" alt="Intro" className="mr-2"/>Intro
                                    </a></Link>
                                    <Link href={`/nutritional-advisors`}><a className="d-block py-2">
                                        <Image width={35} src="/images/sections/img-meet-our-wellness-experts-01.svg" alt="Welcome" className="mr-2"/>Meet the Scientists
                                    </a></Link>
                                    {
                                    /*
                                    <Link href={`/learn-and-earn/overview`} passHref><a className="d-block py-2">
                                        <Image width={35} src="/images/sections/img-learn-and-earn-program-01.svg" alt="Learn & Earn" className="mr-2"/>Learn &amp; Earn
                                    </a></Link>
                                    */
                                    }
                                    
                                </div>
                            </Col>
                        </>
                        : null}        
                    </Row>
                </div>
            </NavDropdown>
        </div>
    )
}

export default WSectionsNav
